import { buildPagination } from '../utils/pagination'

export function usePagination(type, params) {
  return buildPagination(type, params)
}
